import React, { useEffect } from "react";
import "./Cancellation_Policy_Inner.css";
import { useDispatch, useSelector } from "react-redux";
import {
  AllReturnPolicy,
  AllReturnPolicyContent,
} from "../../../features/admin/common/Slice";

const Cancellation_Policy_Inner = ({ activeTab, all_cancellation_policy }) => {
  const dispatch = useDispatch();

  return (
    <div className="privacy-policy">
      <h2 className="privacy-title">Cancellation Policy</h2>

      {all_cancellation_policy?.length > 0 ? (
        all_cancellation_policy?.map((item) => (
          <section id={item?.content_id} key={item?.id}>
            <h5 className="section-heading">
              {item?.returnpolicycontent?.name}
            </h5>

            {item?.description && (
              <div
                className="sub-heading"
                dangerouslySetInnerHTML={{
                  __html: item?.description,
                }}
              />
            )}
          </section>
        ))
      ) : (
        <p className="text-center mt-4">Return Policy is not available</p>
      )}
    </div>
  );
};

export default Cancellation_Policy_Inner;
